import { ContactFilterConditionEnum } from 'modules/contacts/enums/contact-enum'
import { ContactFilterTextInterface } from 'modules/contacts/types/contact-filter-interface'

export const defaultSearchFilterValue: ContactFilterTextInterface = {
  searchValue: '',
  compareOperation: ContactFilterConditionEnum.equals,
}
